import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationComponent from "./components/NavigationComponent";
import FooterComponent from "./components/FooterComponent";
import './mlmodels.css';
import Home from "./pages/Home";
import Research from "./pages/Research";
import Tips from "./pages/Tips";
import CV from "./pages/CV";
import Algorise from "./pages/Tips/Algorise";
import Pydamental from './pages/Tips/Pydamental';
import MLModels from './pages/Tips/MLModels';
import Run from './pages/Pandas/index';
import Fit from './pages/lock/Fit';
import Links from './pages/lock/Links';
import Test from './pages/Test';
import { LoginProvider, useLogin } from './pages/contexts/LoginContext';

import LoginModal from './components/LoginModal';
import Profile from './pages/Profile';
const Layout = ({ children }) => {
  const { showLoginModal, setShowLoginModal } = useLogin();

  return (
    <div className="min-h-screen flex flex-col">
      <NavigationComponent />
      <main className="flex-grow">{children}</main>
      <FooterComponent />
      {showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} />}
    </div>
  );
};

const App = () => {
    return (
        <LoginProvider> {/* 整个App都包裹 */}
            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <Layout>
                                <Home />
                            </Layout>
                        }
                    />
                    <Route
                        path="/research"
                        element={
                            <Layout>
                                <Research />
                            </Layout>
                        }
                    />
                    <Route
                        path="/tips"
                        element={
                            <Layout>
                                <Tips />
                            </Layout>
                        }
                    />
                    <Route
                        path="/cv"
                        element={
                            <Layout>
                                <CV />
                            </Layout>
                        }
                    />
                    <Route path="/tips/algorise" element={<Algorise />} />
                    <Route path="/tips/pydamental" element={<Pydamental />} />
                    <Route path="/tips/MLModels" element={<MLModels />} />
                    <Route path="/pandas/index" element={<Run />} />
                    <Route path="/fit" element={<Fit />} />
                    <Route
                        path="/test"
                        element={
                            <Layout>
                                <Test />
                            </Layout>
                        }
                    />
                    <Route path="profile" element={<Profile />} />
                    <Route path="links" element={<Links/>} />
                </Routes>
            </Router>
        </LoginProvider>
    );
};

export default App;